import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userService } from "../services/userService"; 
import { UserState } from "../models/state/userState";
import { UserRequest } from "../models/request/userRequest";
import { UserModel } from "../models/models/userModel";
import { UserResource } from "../models/resource/userResource";
import { UserResponse } from "../models/response/userResponse";

const initialState: UserState = {
  users: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  }, 
  user: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
};
 
export const getUserById = createAsyncThunk<
  UserModel,
  { id: number },
  { rejectValue: string }
>("user/getUserById", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await userService.getUserById(id);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});


export const deleteUser = createAsyncThunk<
UserResponse,
  { data: number },
  { rejectValue: string }
>(
  "offerIssuer/deleteUser",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response =
        await userService.deleteUser(data);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);  


export const saveUser = createAsyncThunk<
  any,
  { data: UserResource },
  { rejectValue: string }
>("user/saveUser", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await userService.saveUser(data);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getUsersList = createAsyncThunk<
  UserResponse,
  { data: UserRequest },
  { rejectValue: string }
>("user/getUsersList", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await userService.getUsersList(data);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
}); 

const userReducer = createSlice({
  name: "user",
  initialState,
  reducers: { },
  extraReducers: (builder) => {
    builder 
      .addCase(saveUser.pending, (state) => {
        state.users.status = "loading";
        state.users.isLoading = true;
      })
      .addCase(saveUser.fulfilled, (state, action) => {
        state.users.status = "idle";
        state.users.data = action.payload;
        state.users.isLoading = false;
      })
      .addCase(saveUser.rejected, (state, action) => {
        state.users.status = "failed";
        state.users.isLoading = false;
        if (action.payload) {
          state.users.error = action.payload;
          state.users.message = action.payload;
        } else {
          state.users.message = "An unexpected error occurred";
        }
      })
      .addCase(getUserById.pending, (state) => {
        state.user.status = "loading";
        state.user.isLoading = true;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.user.status = "idle";
        state.user.data = action.payload;
        state.user.isLoading = false;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.user.status = "failed";
        state.user.isLoading = false;
        if (action.payload) {
          state.user.error = action.payload;
          state.user.message = action.payload;
        } else {
          state.user.message = "An unexpected error occurred";
        }
      })
      .addCase(getUsersList.pending, (state) => {
        state.users.status = "loading";
        state.users.isLoading = true;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.users.status = "idle";
        state.users.data = action.payload;
        state.users.isLoading = false;
      })
      .addCase(getUsersList.rejected, (state, action) => {
        state.users.status = "failed";
        state.users.isLoading = false;
        if (action.payload) {
          state.users.error = action.payload;
          state.users.message = action.payload;
        } else {
          state.users.message = "An unexpected error occurred";
        }
      })  
      .addCase(deleteUser.pending, (state) => {
          state.users.status = "loading";
        })
        .addCase(deleteUser.fulfilled, (state, action) => {
          state.users.status = "idle";
          state.users.data = action.payload;
          state.users.isLoading = false;
        })
        .addCase(deleteUser.rejected, (state, action) => {
          state.users.status = "failed";
          state.users.isLoading = false;
          if (action.payload) {
            state.users.error = action.payload;
            state.users.message = action.payload;
          } else {
            state.users.message = "An unexpected error occurred";
          }
        });
    },
  });

  
export default userReducer.reducer; 